// extracted by mini-css-extract-plugin
export default {"appStats":"AppStats_appStats__kOqbu"};